import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Grid,
  Cell,
  LinearProgress,
  FontIcon,
} from 'react-md';

import loanService from './../../services/loan';
import { baseUrl } from './../../services/endpoints';

import DefaultLayout from './../../components/layouts/default';
import LineChart from './../../components/molecules/charts/lineChart';
import PieChart from './../../components/molecules/charts/pieChart';

import { optionsGET, session } from './../../services/options';

import tutorService from '../../services/tutors';
import roomService from '../../services/rooms';

// Helper: calcula el porcentaje de variación entre dos valores
function calcPercentChange(today, yesterday) {
  if (yesterday === 0 && today === 0) return 0;
  if (yesterday === 0) return 100;
  return Math.round(((today - yesterday) / yesterday) * 100);
}

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loan: { data: [], loading: false, total: 0, todayCount: 0, yesterdayCount: 0 },
      devices: { lastMothDevices: [], data: [], loading: false, total: 0, todayCount: 0, yesterdayCount: 0 },
      academics: { data: [], loading: false, total: 0, todayCount: 0, yesterdayCount: 0 },
      users: { data: [], loading: false, total: 0, todayCount: 0, yesterdayCount: 0 },
      tutors: { data: [], loading: false, total: 0 },
      rooms: { data: [], loading: false, total: 0 },
    };

    this.getLoan = this.getLoan.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.getLoanDevices = this.getLoanDevices.bind(this);
    this.getLoanAcademics = this.getLoanAcademics.bind(this);
  }

  componentDidMount() {
    if (!session.jwt) {
      window.location.reload();
      return;
    }
    this.getLoan('month');
    this.getLoanDevices();
    this.getUsers('month');
    this.getLoanAcademics();
    this.getTutors();
    this.getRooms();
  }

  getLoan(type) {
    this.setState({ loan: { ...this.state.loan, loading: true } });

    function formatDate(date) {
      const startWithYear = /^[0-9]{4}/.test(date);
      const newDate = startWithYear ? date.slice(0, 10).split('-') : date.slice(0, 10).split('/');
      const day = startWithYear ? newDate[2] : newDate[0];
      const month = newDate[1];
      return `${day}/${month}`;
    }

    return loanService.generalReportsLoan({ type }).then(response => {
      const filtered = response.filter(({ result }) => !/error/ig.test(result));

      // Calcular hoy vs ayer
      const today = moment().format('YYYY-MM-DD');
      const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
      const todayCount = filtered
        .filter(item => moment(item.trace_date).format('YYYY-MM-DD') === today)
        .reduce((sum, item) => sum + item.count, 0);
      const yesterdayCount = filtered
        .filter(item => moment(item.trace_date).format('YYYY-MM-DD') === yesterday)
        .reduce((sum, item) => sum + item.count, 0);

      let map_ok = filtered
        .map(element => ({
          Préstamos: element.count,
          result: element.result,
          Fecha: formatDate(element.trace_date),
        }))
        .sort((prev, next) => {
          const prevParts = prev.Fecha.split('/');
          const nextParts = next.Fecha.split('/');
          const prevDay = parseInt(prevParts[0], 10);
          const nextDay = parseInt(nextParts[0], 10);
          const prevMonth = parseInt(prevParts[1], 10);
          const nextMonth = parseInt(nextParts[1], 10);
          if (prevMonth !== nextMonth) return prevMonth - nextMonth;
          return prevDay - nextDay;
        });

      this.setState({
        loan: {
          loading: false,
          data: map_ok,
          total: map_ok.reduce((total, element) => total + element.Préstamos, 0),
          todayCount,
          yesterdayCount,
        },
      });
    }).catch(err => {
      alert('Hubo un error obteniendo la información de la base de datos.');
      console.log(`Unable to get the information from the database: ${err}`);
    });
  }

  getUsers(type) {
    this.setState({ users: { ...this.state.users, loading: true } });

    function formatDate(date) {
      const startWithYear = /^[0-9]{4}/.test(date);
      const newDate = startWithYear ? date.slice(0, 10).split('-') : date.slice(0, 10).split('/');
      const day = startWithYear ? newDate[2] : newDate[0];
      const month = newDate[1];
      return `${day}/${month}`;
    }

    return fetch(`${baseUrl}general_report_loans/?type=${type}&report=user`, optionsGET())
      .then(response => response.json())
      .then(response => {
        let data = response
          .filter(({ result }) => !/error/ig.test(result))
          .sort((prev, next) => {
            if (moment(prev.trace_date) < moment(next.trace_date)) return -1;
            if (moment(prev.trace_date) > moment(next.trace_date)) return 1;
            return 0;
          });

        // Calcular hoy vs ayer
        const today = moment().format('YYYY-MM-DD');
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const todayCount = data
          .filter(item => moment(item.trace_date).format('YYYY-MM-DD') === today)
          .reduce((sum, item) => sum + item.count, 0);
        const yesterdayCount = data
          .filter(item => moment(item.trace_date).format('YYYY-MM-DD') === yesterday)
          .reduce((sum, item) => sum + item.count, 0);

        // Formatear datos para el gráfico con el nombre del usuario (result)
        const formattedData = data.map(element => ({
          Préstamos: element.count,
          Fecha: formatDate(element.trace_date),
          Usuario: element.result || '',
        }));

        this.setState({
          users: {
            loading: false,
            data: formattedData,
            total: formattedData.reduce((total, element) => total + element.Préstamos, 0),
            todayCount,
            yesterdayCount,
          },
        });
      }).catch(err => {
        alert('Hubo un error obteniendo la información de la base de datos.');
        console.log(`Unable to get the information from the database: ${err}`);
      });
  }

  getLoanDevices() {
    this.setState({ devices: { ...this.state.devices, loading: true } });

    return fetch(baseUrl + 'user_traces/devices', optionsGET())
      .then(response => response.json())
      .then(response => {
        // Calcular hoy vs ayer
        const today = moment().format('YYYY-MM-DD');
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const todayCount = response.filter(item => moment(item.inserted_at).format('YYYY-MM-DD') === today).length;
        const yesterdayCount = response.filter(item => moment(item.inserted_at).format('YYYY-MM-DD') === yesterday).length;

        let lastMothDevices = _.filter(response, device => moment(device.inserted_at).unix() >= moment().subtract(1, 'months').unix());

        lastMothDevices = lastMothDevices.reduce((acc, value) => {
          _.filter(acc, (item, i) => item.so === value.so ? acc[i].push(value) : null);
          return acc;
        }, []);

        const devices = response.map(item => ({
          name: item.so || 'Desconocido',
          created: moment(item.inserted_at)
        })).reduce(function (arr, item) {
          let found = false;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].name === item.name) {
              found = true;
              arr[i].count++;
            }
          }
          if (!found) {
            item.count = 1;
            arr.push(item);
          }
          return arr;
        }, []);

        this.setState({
          devices: {
            lastMothDevices,
            loading: false,
            data: devices,
            total: devices.reduce((total, element) => total + element.count, 0),
            todayCount,
            yesterdayCount,
          },
        });
      }).catch(err => {
        alert('Hubo un error obteniendo la información de la base de datos.');
        console.log(`Unable to get the information from the database: ${err}`);
      });
  }

  getLoanAcademics() {
    this.setState({ academics: { ...this.state.academics, loading: true } });

    return fetch(baseUrl + 'user_traces/academics', optionsGET())
      .then(response => response.json())
      .then(response => {
        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

        // Calcular hoy vs ayer
        const today = moment().format('YYYY-MM-DD');
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const todayCount = response.filter(item => moment(item.inserted_at).format('YYYY-MM-DD') === today).length;
        const yesterdayCount = response.filter(item => moment(item.inserted_at).format('YYYY-MM-DD') === yesterday).length;

        let weekdays = response.map(item => ({
          name: dayNames[moment(item.inserted_at).day()]
        })).reduce(function (arr, item) {
          let found = false;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].name === item.name) {
              found = true;
              arr[i].count++;
            }
          }
          if (!found) {
            item.count = 1;
            arr.push(item);
          }
          return arr;
        }, []);

        const dayOrder = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
        weekdays.sort((a, b) => dayOrder.indexOf(a.name) - dayOrder.indexOf(b.name));

        this.setState({
          academics: {
            loading: false,
            data: weekdays,
            total: weekdays.reduce((total, element) => total + element.count, 0),
            todayCount,
            yesterdayCount,
          },
        });
      }).catch(err => {
        alert('Hubo un error obteniendo la información de la base de datos.');
        console.log(`Unable to get the information from the database: ${err}`);
      });
  }

  getTutors = async () => {
    this.setState({ tutors: { loading: true, data: [], total: 0 } });

    try {
      const params = { type: 'month', reserved: 'tutor' };
      const respuesta = await tutorService.generalReportsTutors(params);

      const tutors = Array.isArray(respuesta)
        ? respuesta
            .map(element => ({ Tutores: element.count, Fecha: element.trace_timestamp }))
            .sort((a, b) => moment(a.Fecha) - moment(b.Fecha))
        : [];

      this.setState({
        tutors: {
          loading: false,
          data: tutors,
          total: tutors.reduce((t, e) => t + e.Tutores, 0),
        },
      });
    } catch (error) {
      console.error('Error cargando tutores:', error);
      this.setState({ tutors: { loading: false, data: [], total: 0 } });
    }
  };

  getRooms = async () => {
    this.setState({ rooms: { loading: true, data: [], total: 0 } });

    try {
      const params = { type: 'month', reserved: 'room' };
      const respuesta = await roomService.generalReportsRoom(params);

      const rooms = Array.isArray(respuesta)
        ? respuesta
            .map(element => ({ Salas: element.count, Fecha: element.trace_timestamp }))
            .sort((a, b) => moment(a.Fecha) - moment(b.Fecha))
        : [];

      this.setState({
        rooms: {
          loading: false,
          data: rooms,
          total: rooms.reduce((t, e) => t + e.Salas, 0),
        },
      });
    } catch (error) {
      console.error('Error cargando salas:', error);
      this.setState({ rooms: { loading: false, data: [], total: 0 } });
    }
  };

  // Renderiza el badge de porcentaje
  renderBadge(todayCount, yesterdayCount) {
    const percent = calcPercentChange(todayCount, yesterdayCount);
    const isUp = percent >= 0;
    const style = isUp ? styles.badgeUp : styles.badgeDown;
    const arrow = isUp ? '↑' : '↓';

    return (
      <React.Fragment>
        <span style={style}>{arrow} {Math.abs(percent)}%</span>
        <span style={styles.cardCompare}>Comparado con ayer</span>
      </React.Fragment>
    );
  }

  render() {
    const startOfMonth = moment().startOf('month').format('DD/MM/YYYY');
    const endOfMonth = moment().endOf('month').format('DD/MM/YYYY');
    const monthName = moment().format('MMMM YYYY');

    return (
      <DefaultLayout>
        <Grid style={{ padding: '16px 8px' }}>
          {/* Card informativo del periodo */}
          <Cell size={12}>
            <div style={styles.periodCard}>
              <FontIcon style={{ color: '#F5A623', fontSize: 22, marginRight: 10 }}>date_range</FontIcon>
              <div>
                <span style={styles.periodTitle}>
                  Datos del mes actual ({monthName})
                </span>
                <span style={styles.periodSubtitle}>
                  Periodo: {startOfMonth} — {endOfMonth}
                </span>
              </div>
            </div>
          </Cell>

          {/* Préstamos */}
          <Cell size={6}>
            <div style={styles.dashCard}>
              <div style={styles.cardHeader}>
                <div style={styles.cardHeaderLeft}>
                  <span style={styles.cardIcon}>
                    <FontIcon style={{ color: '#F5A623', fontSize: 28 }}>local_library</FontIcon>
                  </span>
                  <div>
                    <span style={styles.cardTotal}>{this.state.loan.total}</span>
                    <span style={styles.cardSubtitle}>Préstamos</span>
                  </div>
                </div>
                <div style={styles.cardHeaderRight}>
                  {this.renderBadge(this.state.loan.todayCount, this.state.loan.yesterdayCount)}
                </div>
              </div>
              <div style={styles.cardBody}>
                {this.state.loan.loading && <LinearProgress id='loanProgress' />}
                {this.state.loan.data && (
                  <LineChart
                    height={250}
                    data={this.state.loan.data}
                    dataKeyX='Fecha'
                    dataKeyY='Préstamos'
                  />
                )}
              </div>
            </div>
          </Cell>

          {/* Dispositivos */}
          <Cell size={6}>
            <div style={styles.dashCard}>
              <div style={styles.cardHeader}>
                <div style={styles.cardHeaderLeft}>
                  <span style={styles.cardIcon}>
                    <FontIcon style={{ color: '#F5A623', fontSize: 28 }}>devices</FontIcon>
                  </span>
                  <div>
                    <span style={styles.cardTotal}>{this.state.devices.total}</span>
                    <span style={styles.cardSubtitle}>Dispositivos</span>
                  </div>
                </div>
                <div style={styles.cardHeaderRight}>
                  {this.renderBadge(this.state.devices.todayCount, this.state.devices.yesterdayCount)}
                </div>
              </div>
              <div style={styles.cardBody}>
                {this.state.devices.loading && <LinearProgress id='devicesProgress' />}
                {this.state.devices.data && (
                  <PieChart
                    height={250}
                    data={this.state.devices.data}
                    dataKey='count'
                    colors={this.state.devices.data.map(item => {
                      const name = (item.name || '').toLowerCase();
                      if (name.includes('ios') || name.includes('iphone') || name.includes('apple')) return '#333333';
                      if (name.includes('android')) return '#F5A623';
                      return '#8884d8';
                    })}
                    showLegend
                  />
                )}
              </div>
            </div>
          </Cell>

          {/* Usuarios */}
          <Cell size={6}>
            <div style={styles.dashCard}>
              <div style={styles.cardHeader}>
                <div style={styles.cardHeaderLeft}>
                  <span style={styles.cardIcon}>
                    <FontIcon style={{ color: '#4CAF50', fontSize: 28 }}>people</FontIcon>
                  </span>
                  <div>
                    <span style={styles.cardTotal}>{this.state.users.total}</span>
                    <span style={styles.cardSubtitle}>Usuarios</span>
                  </div>
                </div>
                <div style={styles.cardHeaderRight}>
                  {this.renderBadge(this.state.users.todayCount, this.state.users.yesterdayCount)}
                </div>
              </div>
              <div style={styles.cardBody}>
                {this.state.users.loading && <LinearProgress id='usersProgress' />}
                {this.state.users.data && (
                  <LineChart
                    height={250}
                    data={this.state.users.data}
                    dataKeyX='Fecha'
                    dataKeyY='Préstamos'
                    lineColor='#4CAF50'
                    tooltipExtra='Usuario'
                  />
                )}
              </div>
            </div>
          </Cell>

          {/* Préstamos por día de la semana */}
          <Cell size={6}>
            <div style={styles.dashCard}>
              <div style={styles.cardHeader}>
                <div style={styles.cardHeaderLeft}>
                  <span style={styles.cardIcon}>
                    <FontIcon style={{ color: '#F5A623', fontSize: 28 }}>pie_chart</FontIcon>
                  </span>
                  <div>
                    <span style={styles.cardTotal}>{this.state.academics.total}</span>
                    <span style={styles.cardSubtitle}>Préstamos por día de la semana</span>
                  </div>
                </div>
                <div style={styles.cardHeaderRight}>
                  {this.renderBadge(this.state.academics.todayCount, this.state.academics.yesterdayCount)}
                </div>
              </div>
              <div style={styles.cardBody}>
                {this.state.academics.loading && <LinearProgress id='academicsProgress' />}
                {this.state.academics.data && (
                  <PieChart
                    height={250}
                    data={this.state.academics.data}
                    dataKey='count'
                    colors={['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF']}
                    showLegend
                  />
                )}
              </div>
            </div>
          </Cell>

          {/* Tutores */}
          {this.props.tutorsBoolean && (
            <Cell size={6}>
              <div style={styles.dashCard}>
                <div style={styles.cardHeader}>
                  <div style={styles.cardHeaderLeft}>
                    <span style={styles.cardIcon}>
                      <FontIcon style={{ color: '#9C27B0', fontSize: 28 }}>school</FontIcon>
                    </span>
                    <div>
                      <span style={styles.cardTotal}>{this.state.tutors.total}</span>
                      <span style={styles.cardSubtitle}>Tutores</span>
                    </div>
                  </div>
                </div>
                <div style={styles.cardBody}>
                  {this.state.tutors.loading && <LinearProgress id='tutorsProgress' />}
                  {this.state.tutors.data && (
                    <LineChart
                      height={250}
                      data={this.state.tutors.data}
                      dataKeyX='Fecha'
                      dataKeyY='Tutores'
                      lineColor='#9C27B0'
                    />
                  )}
                </div>
              </div>
            </Cell>
          )}

          {/* Salas */}
          {this.props.roomsBoolean && (
            <Cell size={6}>
              <div style={styles.dashCard}>
                <div style={styles.cardHeader}>
                  <div style={styles.cardHeaderLeft}>
                    <span style={styles.cardIcon}>
                      <FontIcon style={{ color: '#2196F3', fontSize: 28 }}>meeting_room</FontIcon>
                    </span>
                    <div>
                      <span style={styles.cardTotal}>{this.state.rooms.total}</span>
                      <span style={styles.cardSubtitle}>Salas</span>
                    </div>
                  </div>
                </div>
                <div style={styles.cardBody}>
                  {this.state.rooms.loading && <LinearProgress id='roomsProgress' />}
                  {this.state.rooms.data && (
                    <LineChart
                      height={250}
                      data={this.state.rooms.data}
                      dataKeyX='Fecha'
                      dataKeyY='Salas'
                      lineColor='#2196F3'
                    />
                  )}
                </div>
              </div>
            </Cell>
          )}
        </Grid>
      </DefaultLayout>
    );
  }
}

const styles = {
  dashCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    borderTop: '3px solid #F5A623',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    marginBottom: 16,
    overflow: 'hidden',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '16px 20px 8px 20px',
  },
  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  cardHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  cardIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 44,
    height: 44,
    borderRadius: 10,
    backgroundColor: '#FFF8EC',
  },
  cardTotal: {
    display: 'block',
    fontSize: 28,
    fontWeight: 700,
    color: '#333',
    lineHeight: 1.1,
  },
  cardSubtitle: {
    display: 'block',
    fontSize: 13,
    fontWeight: 500,
    color: '#F5A623',
    marginTop: 2,
  },
  cardBody: {
    padding: '0 12px 16px 12px',
  },
  badgeUp: {
    display: 'inline-block',
    backgroundColor: '#E8F5E9',
    color: '#4CAF50',
    fontSize: 12,
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: 12,
  },
  badgeDown: {
    display: 'inline-block',
    backgroundColor: '#FFEBEE',
    color: '#F44336',
    fontSize: 12,
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: 12,
  },
  cardCompare: {
    fontSize: 11,
    color: '#999',
  },
  periodCard: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: '14px 20px',
    marginBottom: 16,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    borderLeft: '4px solid #F5A623',
  },
  periodTitle: {
    display: 'block',
    fontSize: 15,
    fontWeight: 600,
    color: '#333',
  },
  periodSubtitle: {
    display: 'block',
    fontSize: 13,
    color: '#777',
    marginTop: 2,
  },
};

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps)(Home);
